<template>
  <div class="wrapper">
    <Tabs v-model="activeTab" @input="changeTab" class="empty-tab">
      <Tab
        :key="`tab-${index}`"
        v-for="(item, index) of tabs"
        :header="item.label"
      >
      </Tab>
    </Tabs>
    <router-view></router-view>
  </div>
</template>

<script>
import Tabs from "vue-strap/src/Tabs";
import Tab from "vue-strap/src/Tab";

import { mapState } from "vuex";

export default {
  components: {
    Tabs,
    Tab,
  },
  data() {
    return {
      activeTab: 0,
      tabs: [
        { label: "Données", name: "data", children: ["prospects", "clients"] },
        {
          label: "Relance perdus",
          name: "lost-relaunch",
          children: [
            "clients-lost-relaunch-list",
            "prospects-lost-relaunch-list",
          ],
        },
      ],
    };
  },
  computed: {
    ...mapState({
      user: (state) => state.user,
    }),
  },
  created() {
    this.setCurrentTab(this.$route.name);
  },
  methods: {
    changeTab(index) {
      this.$router.push({ name: this.tabs[index].name });
    },

    setCurrentTab(currentPath) {
      const parentTab = this.tabs.find((tab) =>
        tab.children?.includes(currentPath),
      );

      this.activeTab = this.tabs.findIndex((tab) => {
        return parentTab
          ? tab.name === parentTab.name
          : tab.name === currentPath;
      });
    },
  },
  watch: {
    $route(current) {
      const parentTab = this.tabs.find((tab) =>
        tab.children?.includes(current.name),
      );

      this.setCurrentTab(parentTab ? parentTab.name : current.name);
    },
  },
};
</script>

<style lang="scss">
.empty-tab {
  .nav.nav-tabs {
    margin-bottom: 15px;
  }

  & > .tab-content {
    display: none !important;
  }
}
</style>
